import "../../styles/global.scss";
import { Container, Row, Col, Card } from "react-bootstrap";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { serverUrl } from "../../helpers/utility";
import { useLocation, Link } from "react-router-dom";
import logo from "../../images/logo.png";

function VerifyEmail() {
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const token = searchParams.get("token");
  const [status, setStatus] = useState("pending"); // pending | success | error | need-auth
  const [message, setMessage] = useState("");

  useEffect(() => {
    async function confirm() {
      if (!token) {
        setStatus("need-auth");
        setMessage("Use the link from your email to verify. You can request a new one when logged in.");
        return;
      }

      try {
        await axios.post(`${serverUrl}/auth/verify-email`, { token });
        setStatus("success");
        setMessage("Email verified successfully.");
      } catch (err) {
        console.error(`ERR: verify-email. ${err}`);
        setStatus("error");
        setMessage(err?.response?.data?.message || "Verification link is invalid or expired.");
      }
    }

    confirm();
  }, [token]);

  async function requestVerification() {
    try {
      setStatus("pending");
      setMessage("Sending verification email...");
      await axios.post(`${serverUrl}/auth/send-verify`);
      setStatus("success");
      setMessage("Verification email sent. Please check your inbox.");
    } catch (err) {
      console.error(`ERR: send-verify. ${err}`);
      setStatus("error");
      setMessage(err?.response?.data?.message || "Could not send verification email.");
    }
  }

  return (
    <Container fluid className={`no-padding no-margin container-fluid`}>
      <Row className="justify-content-center" style={{ paddingTop: 40 }}>
        <Col lg={5}>
          <Card>
            <Card.Body style={{ padding: 24 }}>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
                <img src={logo} style={{ height: 32 }} />
              </div>
              <h3 className="h4 mb-2 text-center">Verify email</h3>
              {status === "pending" ? (
                <div className="text-center text-muted">Checking your link...</div>
              ) : null}
              {status === "success" ? (
                <div className="alert alert-success text-center">{message}</div>
              ) : null}
              {status === "error" ? (
                <div className="alert alert-danger text-center">{message}</div>
              ) : null}
              {status === "need-auth" ? (
                <>
                  <div className="alert alert-warning text-center">{message}</div>
                  <div className="text-center">
                    <button className="btn btn-primary" onClick={requestVerification}>
                      Send verification email
                    </button>
                  </div>
                  <p className="text-center mt-3">
                    <Link to="/login">Back to login</Link>
                  </p>
                </>
              ) : null}
              {status === "success" ? (
                <p className="text-center mt-3">
                  <Link to="/login">Back to login</Link>
                </p>
              ) : null}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default VerifyEmail;

